import * as React from 'react';

import {Button} from 'shells/button/button';
import {CloseButton} from 'shells/button/close-button/close-button';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Popover} from 'shells/popover/popover';
import {TextField} from 'shells/textfield/textfield';

// @ts-expect-error
import getClassesMixin from '../mixins/get-classes';

type Props = {
    anchor: HTMLElement | null | undefined;
    location: string;
    onSave: (filterName: string) => any;
    onClose: () => any;
    isSaving: boolean;
    title: string;
    placeholderText: string;
    errorText: string | null | undefined;
    onDismissError: () => any;
};

type State = {
    filterName: string;
};

export class FilterSavePopover extends React.Component<Props, State> {
    getClasses = getClassesMixin;
    textFieldRef: HTMLInputElement | null | undefined;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            filterName: '',
        };
    }

    componentDidMount() {
        if (this.textFieldRef) {
            // Not using the autoFocus prop on the TextField below
            // because it happens too fast for the select() callback
            // to happen
            this.textFieldRef.focus();
        }
    }

    render() {
        const hasError = this.props.errorText && this.props.errorText.length;
        const classes = this.getClasses(
            `ui-popover ui-popover--filter-save ui-popover-form ${
                hasError ? 'has-error-banner' : ''
            }`
        );

        return (
            <Popover
                className={classes}
                anchor={this.props.anchor}
                // @ts-expect-error
                location={this.props.location}
                onBlur={this.props.onClose}
            >
                {hasError && (
                    <FlashBanner
                        type='error'
                        duration={4000}
                        isOverlay={true}
                        onHidden={this.props.onDismissError}
                    >
                        {this.props.errorText}
                    </FlashBanner>
                )}
                <div className='toolbar'>
                    <h1 className='ui-header ui-header--md'>{this.props.title}</h1>
                </div>
                <form onSubmit={this.handleSubmit} className='inner-wrapper'>
                    <CloseButton className='ui-btn__popover-close' onClick={this.props.onClose} />
                    <TextField
                        textFieldRef={(node) => {
                            this.textFieldRef = node;
                        }}
                        // @ts-expect-error
                        className='ui-input--no-focus ui-input--full-width'
                        placeholder={this.props.placeholderText}
                        value={this.state.filterName}
                        onChange={this.handleChange}
                    />
                    <div className='save-button'>
                        <Button
                            type='submit'
                            size='big'
                            disabled={this.state.filterName.length < 3}
                            variant='save'
                            onClick={this.handleSubmit}
                        >
                            {this.props.isSaving ? 'Saving…' : 'Save'}
                        </Button>
                    </div>
                </form>
            </Popover>
        );
    }

    handleChange = (newVal: string) => {
        this.setState({filterName: newVal});
    };

    handleSubmit = (e: React.SyntheticEvent<any>) => {
        e.preventDefault();

        this.props.onSave(this.state.filterName);
    };
}
